import { LoadableAfterPaint } from '@confluence/loadable';

export const UpgradeFreePoolExperimentModalPostUpgradeModalLoadable = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-UpgradeFreePoolExperimentModalPostUpgrade" */ './base-component'
			)
		).UpgradeFreePoolExperimentModalPostUpgradeModalBaseComponent,
});
